import * as type from './actionTypes/loginActionTypes';

export const errorSignin = value => ({
  type: type.ERROR_SIGNIN_USER,
  value
});

export const successPasswordChange = value => ({
  type: type.SUCCESS_PASSWORD_CHANGE,
  value
});

export const signOutUser = payload => ({
  type: type.SIGN_OUT_USER,
  payload
});

export const verifyUser = payload => ({
  type: type.VERIFY_USER,
  payload
});

export const poolData = value => ({
  type: type.POOL_DATA,
  value
});

export const setSignInUser = value => ({
  type: type.SET_SIGN_IN_USER,
  value
});

export const setForgotPasswordEmail = value => ({
  type: type.SET_FORGOT_PASSWORD_EMAIL,
  value
});
